import { render, staticRenderFns } from "./StudentSubmissionList.vue?vue&type=template&id=6ff39dbf&scoped=true"
import script from "./StudentSubmissionList.vue?vue&type=script&lang=js"
export * from "./StudentSubmissionList.vue?vue&type=script&lang=js"
import style0 from "./StudentSubmissionList.vue?vue&type=style&index=0&id=6ff39dbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff39dbf",
  null
  
)

export default component.exports